export * from "-!../../node_modules/framevuerk-builder/node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../node_modules/framevuerk-builder/node_modules/pug-html-loader/lib/index.js!../../node_modules/framevuerk-builder/node_modules/vue-loader/lib/index.js??vue-loader-options!./fvTextarea.vue?vue&type=template&id=6bf3fefe&lang=pug&"


//////////////////
// WEBPACK FOOTER
// ./src/components/fvTextarea.vue?vue&type=template&id=6bf3fefe&lang=pug&
// module id = 155
// module chunks = 0 1